
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontactcollection } from '../../api/contactcollection.api'

import './nuevoiniciowdgyp.scss';








const Pnuevoiniciowdgyp = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id66a4dbc0914da0d427ff343c" >

      <div id="if9wqu" className="">
      
      <div id="ihuh" className="">
      
      <div id="inlc" className="">
      
      <img
        className=""
        id="illj"
        src="https://assetsprojects.s3.amazonaws.com/eewk3il9h8z7ui.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="idpf" className="">
      
      <div id="i9ute" className="">
      
        <a
          target=""
          className=""
          id="i34ziv"
          href="#itkxb"
        >
          
      <div className="" id="ihn67">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      <>Nuestros Servicios</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i7cvw" className="">
      
        <a
          target=""
          className="link-menu "
          id="inlxjs"
          href="#ioyle"
        >
          
      <div className="" id="i2d1h">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      <>Misión y visión</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4d8t" className="">
      
        <a
          target=""
          className=""
          id="iv6wxw"
          href="#if7cvl"
        >
          
      <div className="" id="izded">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      <>Sobre Nosotros</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ihh3i" className="">
      
        <a
          target=""
          className=""
          id="id21rj"
          href="#im8uk6"
        >
          
      <div className="" id="ih8nn">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="izrqjl" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iz8mc" className="">
      
      <div id="irkrg" className="">
      
      <div id="icjaj" className="">
      
      <div id="ibwb9" className="">
      
      <div id="i9a0g" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="irey9">
        <>PROTEGE TU EMPRESA CON SOLUCIONES DE CIBERSEGURIDAD</>
      </div>
      <>
        </>
      </div>
      
      <div id="il8ni" className="">
      
      <div className="" id="ibn48">
        <>Somos expertos en ciberseguridad con soluciones Fortinet. Fortalece tu defensa cibernética y asegura la tranquilidad de tu negocio con nosotros</>
      </div>
      <>
        </>
      </div>
      
      <div id="i7yrj" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i7rzq" className="">
      
      <img
        className=""
        id="iq0wx"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42einy.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="itkxb" className="">
      
      <div id="igk42" className="">
      
      <div id="i2k9f" className="">
      <>
        </>
      </div>
      
      <div id="i8yjmg" className="">
      
      <div id="i1giw1" className="">
      
      <div id="ir7b67" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iqqtir">
        <>Nuestros servicios</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iy0kzs" className="">
      
      <div id="i0r22k" className="gjs-row ">
      
      <div id="im9aj8" className="gjs-cell ">
      
      <div id="ir9tjg" className="">
      
      <img
        className=""
        id="ixv5q1"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42ng6m.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ieve6s" className="">
      
      <div className="titulo " id="ixpmmi">
        <>Soluciones de Red</>
      </div>
      <>
        </>
      </div>
      
      <div id="i0iq35" className="">
      
      <div className="descripcion " id="iq6w0u">
        <>Ofrecemos servicios de red que integran seguridad y conectividad de alta calidad.</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="inhjxp" className="gjs-cell ">
      
      <div id="itukty" className="">
      
      <img
        className=""
        id="iozicg"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42l6ts.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="in31bh" className="">
      
      <div className="titulo " id="irdrs2">
        <>Implementación de Servidores</>
      </div>
      <>
        </>
      </div>
      
      <div id="i8cii2" className="">
      
      <div className="descripcion " id="ibjm4s">
        <>Una de las áreas tecnológicas que más ha evolucionado en los últimos años es el usoi de esquemas híbridos para implementción de los sistemas operativos de las empresas</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i79oau" className="gjs-cell ">
      
      <div id="i4fovp" className="">
      
      <img
        className=""
        id="ivqqvb"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42mkuo.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iih9g6" className="">
      
      <div className="titulo " id="icpg6x">
        <>Consultoría de Seguridad Informatica</>
      </div>
      <>
        </>
      </div>
      
      <div id="ikyklj" className="">
      
      <div className="descripcion " id="irckav">
        <>Haciendo uso de herramientas especializadas por marcas líderes a nivel global, prodemos brindarles un enfoque profesional para el estudio de la infraestructura de Ciberseguridad con la que cuenta su empresa</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="izacmz" className="gjs-cell ">
      
      <div id="i0zxgk" className="">
      
      <img
        className=""
        id="i8mlj4"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42n4fc.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i0ny5i" className="">
      
      <div className="titulo " id="iz8kkg">
        <>Seguridad de Aplicaciones Web</>
      </div>
      <>
        </>
      </div>
      
      <div id="iazuqc" className="">
      
      <div className="descripcion " id="i6y3mj">
        <>Protegemos sus aplicaciones web contra una aplia gama de amenazas, incluyendo ataques de dia cero, inyecciones SQL, cross-site scripting &#40;XSS). Este servicio garantiza la integridad y seguridad de sus aplicaciones en línea.</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ioyle" className="">
      
      <div id="iqrg2c" className="">
      
      <div id="inrd62" className="">
      
      <div id="i2addl" className="">
      
      <div className="" id="iytiv9">
        <>Misión</>
      </div>
      
      <div className="" id="iz6kkb">
        <>Nuestra misión es proteger tu infraestructura digital contra amenazas avanzadas, asegurando la continuidad de tu negocio. Desde la implementación de firewalls de última generación hasta la gestión de seguridad een la nube, brindamos servicios personalizados y soporte 24/7 para maneter tus datos y operaciones seguras.</>
      </div>
      <>
        </>
      </div>
      
      <div id="iv229g" className="">
      
      <div className="" id="i4op39">
        <>Visión</>
      </div>
      
      <div className="" id="i0hy6h">
        <>Ser líderes globales en ciberseguridad, ofreciendo soluciones innovadoras y efectivas que protejan a empresas de todos los tamaños contra las amenazas digitales. Aspiramos a crear un mundo digital más seguro, donde la tecnología y la información estén resguardadas con los más altos estándares de seguridad, permitiendo a nuestros clientes operar con confianza y tranquilidad en la era digital.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="if7cvl" className="">
      
      <div id="i7v3nj" className="">
      
      <div id="iri6nk" className="">
      <>
        </>
      </div>
      
      <div id="is9fbi" className="">
      
      <div id="ibsh6e" className="">
      
      <div id="i4e2g8" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="ilpn6s">
        <>Sobre Nosotros</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i13hzg" className="">
      
      <div id="i95cyf" className="gjs-row ">
      
      <div id="itnnmf" className="gjs-cell ">
      
      <div id="ifpf28" className="">
      
      <div className="" id="im9bd5">
        <>En Black Maker, nos dedicamos a proporcionar soluciones de ciberseguridad de vanguardia con el respaldo de Fortinet. Nuestro equipo de expertos está comprometido con proteger tu infraestructura digital contra amenazas avanzadas, garantizando la seguridad y continuidad de tu negocio. </>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Con un enfoque personalizado y soporte 24/7, trabajamos incansablemente para ofrecerte las herramientas y la tranquilidad que necesitas en un mundo cada vez más digital. Confía en nosotros para fortalecer tu defensa cibernética y llevar tu empresa al siguiente nivel de seguridad.</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="iydl7f" className="gjs-cell ">
      
      <div id="i1aejp" className="">
      
      <img
        className=""
        id="ihijoh"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilz42zoxh.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i5p3xm" className="">
      
      <div className="" id="iql052">
        <> ¡Asegura tu tranquilidad hoy mismo!</>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="im8uk6" className="">
      
      <div id="ile7op" className="">
      
      <div id="ixmaj4" className="">
      <>
        </>
      </div>
      
      <div id="i7vpvm" className="">
      
      <div id="i4569h" className="">
      
      <div id="i98nvj" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iwrrfj">
        <>CONTACTO</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iz6bji" className="">
      
      <div id="imey7v" className="">
      
      <div id="iaovx1" className="">
      
      <div className="" id="iqkjvg">
        <>¿Tienes alguna pregunta o necesitas más información sobre nuestras soluciones de ciberseguridad? ¡Estamos aquí para ayudarte! Ponte en contacto con nosotros a través de los siguientes medios:</>
      </div>
      
      <div className="" id="i8aw0j">
        
      <p className="MsoNormal " id="">
        <>Dirección</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      <div className="" id="is6mpj">
        <>Oficina Beetik, Novacentro, Tegucigalpa, Honduras</>
      </div>
      
      <div className="" id="il35yc">
        <>Correo</>
      </div>
      
      <div className="" id="ixvud7">
        <>alejandro.valladares@black-maker.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="id6zqn" className="">
      
      <div id="is5k2g" className="">
      
        <div className="" id="iuu374">
          <>
      </>
      <form
        id="ittqxg"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontactcollection({
						token: 'aasdas',
						namecontact: e.target.namecontact?.value,
						phonenumber: e.target.phonenumber?.value,
						emailcontact: e.target.emailcontact?.value,
						contactmessage: e.target.contactmessage?.value,
					});
				} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="igy239" className="">
      
      <label id="iet9pr" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="namecontact"
        type="text"
        placeholder=""
        className=""
        id="in7yge"
      />
      
      <div id="iaeliw" className="">
      <>
        </>
      </div>
      
      </div>
      
      <div id="iss7og" className="">
      
      <label id="idvkmj" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="phonenumber"
        type="text"
        placeholder=""
        className=""
        id="i19iif"
      />
      
      <div id="iuknkx" className="">
      <>
        </>
      </div>
      
      </div>
      
      <div id="is643o" className="">
      
      <label id="ioozel" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="emailcontact"
        type="text"
        placeholder=""
        className=""
        id="ity6ca"
      />
      
      <div id="ie2pxa" className="">
      <>
        </>
      </div>
      
      </div>
      
      <div id="ihvc7j" className="">
      
      <label id="iq375g" className="">
      <>Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="contactmessage"
        type="text"
        placeholder=""
        className=""
        id="ik91rd"
      />
      
      <div id="ilgeip" className="">
      <>
        </>
      </div>
      
      </div>
      
      <button
        type="submit"
        name=""
        id="i58n9p"
        className=""
        
      >
      <>ENVIAR MENSAJE
              </>
      </button>
      
      </form>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i77go" className="">
      
      <img
        className=""
        id="i2x09m"
        src="https://assetsprojects.s3.amazonaws.com/eewk3il9hjl0pb.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="imxd3m"
        src="https://assetsprojects.s3.amazonaws.com/eewk3il9hjs930.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="is3wb5"
        src="https://assetsprojects.s3.amazonaws.com/eewk3il9hjspxc.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ilkxzh" className="">
      
      <div className="" id="ikgcxg">
        <>© 2024 blackmaker,  All Rights Reserved</>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pnuevoiniciowdgyp);
  